import { Text, Group, Badge, ThemeIcon, BadgeProps } from "@mantine/core";
import { IconCoin } from "@tabler/icons-react";
import useGetIdeiaActivityByColaborador from "../../hooks/useGetIdeiaActivityByColaborador";

const TotalMoedasPerColaborador = ({
  ideia,
  colaboradorId,
  ...badgeProperties
}: { ideia: TIdeia; colaboradorId: TColaborador["id"] } & BadgeProps) => {
  const { data: ideiaActivity } = useGetIdeiaActivityByColaborador(ideia, colaboradorId);

  const qtdMoedasGastasNestaIdeia = ideiaActivity?.moedas ?? 0;

  return (
    <Group align="center" gap="xs">
      <Badge
        color="gray.2"
        py="md"
        px="md"
        radius="md"
        h="auto"
        style={{ minHeight: "32px" }}
        leftSection={
          <ThemeIcon variant="light" color="yellow" size="sm">
            <IconCoin />
          </ThemeIcon>
        }
        {...badgeProperties}
      >
        <Text c="dark" fz="xs" fw={500} tt="lowercase">
          {qtdMoedasGastasNestaIdeia} moedas
        </Text>
      </Badge>
    </Group>
  );
};

export default TotalMoedasPerColaborador;
